import Emotion1Icon from "../../../images/icons/user_feedback_icons/happy5.svg";
import Emotion2Icon from "../../../images/icons/user_feedback_icons/happy4.svg";
import Emotion3Icon from "../../../images/icons/user_feedback_icons/happy3.svg";
import Emotion4Icon from "../../../images/icons/user_feedback_icons/happy2.svg";
import Emotion5Icon from "../../../images/icons/user_feedback_icons/happy.svg";
import Emotion6Icon from "../../../images/icons/user_feedback_icons/neutral.svg";
import Emotion7Icon from "../../../images/icons/user_feedback_icons/sad.svg";
import Emotion8Icon from "../../../images/icons/user_feedback_icons/cry3.svg";
import Emotion9Icon from "../../../images/icons/user_feedback_icons/cry2.svg";
import Emotion10Icon from "../../../images/icons/user_feedback_icons/cry.svg";

export const COACHING_METHODOLOGY_RATING_FACTORS = [
  { id: "1", description: "Communication and support", checked: false },
  { id: "2", description: "Actionable plans", checked: false },
  {
    id: "3",
    description: "The steps involved (e.g. PDCA, coaching regularity)",
    checked: false,
  },
  { id: "4", description: "Coaching subjects", checked: false },
  { id: "5", description: "Others", checked: false },
];
export const ACCESSIBILITY_FACTORS = [
  { id: "1", description: "The page was lagging", checked: false },
  { id: "2", description: "VPN access not functioning", checked: false },
  {
    id: "3",
    description: "Certain features did not load",
    checked: false,
  },
  { id: "4", description: "Limited bandwidth in my workplace", checked: false },
  { id: "5", description: "Others (please specify)", checked: false },
];

export const HELPFUL_FEATURES = [
  {
    id: "1",
    description: "Session creation (subjects, scores, checkpoints)",
    checked: false,
  },
  { id: "2", description: "Session calendar", checked: false },
  {
    id: "3",
    description: "Session reminders",
    checked: false,
  },
  { id: "4", description: "Keypoints and Notes", checked: false },
  { id: "5", description: "Compliments", checked: false },
  { id: "6", description: "Others (please specify)", checked: false },
];

// export const FLASH_COACH_TRAINING_RATING = [
//   {
//     rating: 10,
//     name: "Outstanding",
//     description: "Communication and support",
//     isSelected: false,
//     imageSrc: Emotion1Icon,
//   },
//   {
//     rating: 9,
//     name: "Excellent",
//     description: "I feel confident to kick-start the system",
//     isSelected: false,
//     imageSrc: Emotion2Icon,
//   },
//   {
//     rating: 8,
//     name: "Very good",
//     description: "I was assured of its functions",
//     isSelected: false,
//     imageSrc: Emotion3Icon,
//   },
//   {
//     rating: 7,
//     name: "Good",
//     description: "I was quite clear with the instructions",
//     isSelected: false,
//     imageSrc: Emotion4Icon,
//   },
//   {
//     rating: 6,
//     name: "Above average",
//     description: "I got my basic questions answered",
//     isSelected: false,
//     imageSrc: Emotion5Icon,
//   },
//   {
//     rating: 5,
//     name: "Average",
//     description: "I was left feeling a little clueless",
//     isSelected: false,
//     imageSrc: Emotion6Icon,
//   },
//   {
//     rating: 4,
//     name: "Below average",
//     description: "I was doubtful",
//     isSelected: false,
//     imageSrc: Emotion7Icon,
//   },
//   {
//     rating: 3,
//     name: "Poor",
//     description: "I was at a loss most of the time",
//     isSelected: false,
//     imageSrc: Emotion8Icon,
//   },
//   {
//     rating: 2,
//     name: "Extremely poor",
//     description: "I was significantly puzzled",
//     isSelected: false,
//     imageSrc: Emotion9Icon,
//   },
//   {
//     rating: 1,
//     name: "Totally helpless",
//     description: "I was significantly puzzled",
//     isSelected: false,
//     imageSrc: Emotion10Icon,
//   },
// ];

export const FLASH_COACH_TRAINING_RATING = [
  {
    rating: 10,
    name: "Outstanding",
    description: "I feel very well-prepared",
    isSelected: false,
    imageSrc: Emotion1Icon,
  },
  {
    rating: 9,
    name: "Excellent",
    description: "I feel confident to kick-start the system",
    isSelected: false,
    imageSrc: Emotion2Icon,
  },
  {
    rating: 8,
    name: "Very good",
    description: "I was assured of its functions",
    isSelected: false,
    imageSrc: Emotion3Icon,
  },
  {
    rating: 7,
    name: "Good",
    description: "I was quite clear with the instructions",
    isSelected: false,
    imageSrc: Emotion4Icon,
  },
  {
    rating: 6,
    name: "Above average",
    description: "I got my basic questions answered",
    isSelected: false,
    imageSrc: Emotion5Icon,
  },
  {
    rating: 5,
    name: "Average",
    description: "I was left feeling a little clueless",
    isSelected: false,
    imageSrc: Emotion6Icon,
  },
  {
    rating: 4,
    name: "Below average",
    description: "I was doubtful",
    isSelected: false,
    imageSrc: Emotion7Icon,
  },
  {
    rating: 3,
    name: "Poor",
    description: "I was at a loss most of the time",
    isSelected: false,
    imageSrc: Emotion8Icon,
  },
  {
    rating: 2,
    name: "Extremely poor",
    description: "I was significantly puzzled",
    isSelected: false,
    imageSrc: Emotion9Icon,
  },
  {
    rating: 1,
    name: "Totally helpless",
    description: "I was not given any training",
    isSelected: false,
    imageSrc: Emotion10Icon,
  },
];
export const EASE_OF_NAVIGATION_RATING = [
  {
    rating: 10,
    description: "All clear and smooth",
    isSelected: false,
    imageSrc: Emotion1Icon,
  },
  {
    rating: 9,
    description: "Extremely easy",
    isSelected: false,
    imageSrc: Emotion2Icon,
  },
  {
    rating: 8,
    description: "Very easy",
    isSelected: false,
    imageSrc: Emotion3Icon,
  },
  {
    rating: 7,
    description: "It's easy",
    isSelected: false,
    imageSrc: Emotion4Icon,
  },
  {
    rating: 6,
    description: "Fairly easy",
    isSelected: false,
    imageSrc: Emotion5Icon,
  },
  {
    rating: 5,
    description: "Somewhat challenging",
    isSelected: false,
    imageSrc: Emotion6Icon,
  },
  {
    rating: 4,
    description: "It's challenging",
    isSelected: false,
    imageSrc: Emotion7Icon,
  },
  {
    rating: 3,
    description: "Very difficult",
    isSelected: false,
    imageSrc: Emotion8Icon,
  },
  {
    rating: 2,
    description: "Extremely difficult",
    isSelected: false,
    imageSrc: Emotion9Icon,
  },
  {
    rating: 1,
    description: "Totally lost",
    isSelected: false,
    imageSrc: Emotion10Icon,
  },
];
// export const ACCESSIBILITY_RATING = [
//   {
//     rating: 10,
//     description: "All clear and smooth",
//     isSelected: false,
//     imageSrc: Emotion1Icon,
//   },
//   {
//     rating: 9,
//     description: "Extremely easy",
//     isSelected: false,
//     imageSrc: Emotion2Icon,
//   },
//   {
//     rating: 8,
//     description: "Very easy",
//     isSelected: false,
//     imageSrc: Emotion3Icon,
//   },
//   {
//     rating: 7,
//     description: "It's easy",
//     isSelected: false,
//     imageSrc: Emotion4Icon,
//   },
//   {
//     rating: 6,
//     description: "Fairly easy",
//     isSelected: false,
//     imageSrc: Emotion5Icon,
//   },
//   {
//     rating: 5,
//     description: "Somewhat challenging",
//     isSelected: false,
//     imageSrc: Emotion6Icon,
//   },
//   {
//     rating: 4,
//     description: "It's challenging",
//     isSelected: false,
//     imageSrc: Emotion7Icon,
//   },
//   {
//     rating: 3,
//     description: "Very difficult",
//     isSelected: false,
//     imageSrc: Emotion8Icon,
//   },
//   {
//     rating: 2,
//     description: "Extremely difficult",
//     isSelected: false,
//     imageSrc: Emotion9Icon,
//   },
//   {
//     rating: 1,
//     description: "Totally lost",
//     isSelected: false,
//     imageSrc: Emotion10Icon,
//   },
// ];

export const ACCESSIBILITY_RATING = [
  {
    rating: 10,
    description: "It was instantaneous",
    isSelected: false,
    imageSrc: Emotion1Icon,
  },
  {
    rating: 9,
    description: "It was really fast ",
    isSelected: false,
    imageSrc: Emotion2Icon,
  },
  {
    rating: 8,
    description: "It was fast",
    isSelected: false,
    imageSrc: Emotion3Icon,
  },
  {
    rating: 7,
    description: "It's fairly smooth",
    isSelected: false,
    imageSrc: Emotion4Icon,
  },
  {
    rating: 6,
    description: "It's fine, with few delays",
    isSelected: false,
    imageSrc: Emotion5Icon,
  },
  {
    rating: 5,
    description: "Somewhat slow",
    isSelected: false,
    imageSrc: Emotion6Icon,
  },
  {
    rating: 4,
    description: "It's slow and buggy",
    isSelected: false,
    imageSrc: Emotion7Icon,
  },
  {
    rating: 3,
    description: "Very buggy",
    isSelected: false,
    imageSrc: Emotion8Icon,
  },
  {
    rating: 2,
    description: "Extremely buggy",
    isSelected: false,
    imageSrc: Emotion9Icon,
  },
  {
    rating: 1,
    description: "Totally inaccessible",
    isSelected: false,
    imageSrc: Emotion10Icon,
  },
];

export const INITIAL_FORM_DATA = {
  coachingMethodologyRating: "",
  coachingMethodologyRatingFactors: COACHING_METHODOLOGY_RATING_FACTORS,
  coachingMethodologyFeedback: "",
  growthSupportFeedback: "",
  processImprovementFeedback: "",
  flashCoachPlatformRating: "",
  flashCoachTrainingRating: FLASH_COACH_TRAINING_RATING,
  easeOfNavigationRating: EASE_OF_NAVIGATION_RATING,
  easeOfNavigationFeedback: "",
  accessibilityRating: ACCESSIBILITY_RATING,
  accessibilityFactors: ACCESSIBILITY_FACTORS,
  accessibilityFactorsOthers: "",
  helpfulFeatures: HELPFUL_FEATURES,
  helpfulFeaturesOthers: "",
  improvementSuggestion: "",
  supportRating: "",
};
